import { networkCall } from "../../../../utils/network-call/network-call";

export const CmsLayoutLoader = async () => {
    const getUserResponse = await networkCall('/users/me');
    return { getUserResponse };
};